import React from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import parse from "html-react-parser";

import { ToastContainer, toast } from "react-toastify";
import { HomePageCTAInterface } from "../../interfaces/homePageInterfaces";

type CallToActionCpntProps = {
  content: HomePageCTAInterface | undefined;
};

type Message = {
  messageCta: string;
  emailCta: string;
  acceptTerms: boolean;
};

const CallToActionCpnt = ({ content }: CallToActionCpntProps): JSX.Element => {
  const { register, handleSubmit, reset } = useForm<Message>();

  const submitCtaForm = handleSubmit(async ({ messageCta, emailCta }) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}static/scripts/mail.php`, {
        message: messageCta,
        email: emailCta,
      });

      if (response.data.status === "success") {
        toast.success("Votre message a bien été adressé à TOOGETHER", {});
        reset();
      }

      if (response.data.status === "fail") throw new Error("Erreur lors de l'envoi de votre message");
    } catch (error) {
      toast.error(`${error}`, {});
    }
  });

  return (
    <article className="call-to-action-article" id="nous-contacter">
      <section className="ctaa-section">
        <div className="ctaas-before"></div>
        <div className="ctaas-cta">
          <h2 className="ctaascta-title">{content ? parse(content.title || "") : ""}</h2>
          {/* <p className="ctaascta-advice">
                        Posez nous toutes vos questions
                    </p> */}
          <form onSubmit={submitCtaForm} className="ctaascta-form" method="post">
            <textarea
              className="ctaasctaf-text-area"
              ref={register({ required: true })}
              name="messageCta"
              id="messageCta"
              aria-label="Message"
              placeholder="Posez-nous vos questions *"
              required></textarea>
            <input
              className="ctaascta-email"
              ref={register({ required: true })}
              type="email"
              name="emailCta"
              id="emailCta"
              aria-label="Email"
              placeholder="E-mail *"
              required
            />
            <div className="ctaasctaf-legals">
              <input
                className="ctaasctafl-checkbox"
                ref={register({ required: true })}
                type="checkbox"
                name="acceptTerms"
                id="accept"
                aria-label="accept terms"
                required
              />
              <label htmlFor="accept" className="ctaasctafl-text">
                {content?.annotation}{" "}
              </label>
            </div>
            <input className="ctaasctaf-submit" type="submit" aria-label="Envoyer" value={content?.button} />
          </form>
        </div>
      </section>
      <ToastContainer
        position="bottom-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </article>
  );
};

export default CallToActionCpnt;
